// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"5e755fbeb470b759","7390":"77e3b8f70a700cd1"}[chunkId] + ".css";
};